import React from "react";
import appContext from "../../../appContext";
import NoResultImage from "../../../assets/emptystats/noresult.svg";

import { useMediaQuery } from "@mui/material";
import { TakeToTemplatesButton } from "../Buttons";
import { NoResultFoundPropType, textConstants } from "./utils";
import { sidebarValueConstants } from "../../../pages/Workspace/sidebarutils";

import {
  RootContainer,
  ImageContainer,
  PreviewImage,
  TextContainer,
  SubHeaderText,
  HeaderText,
  ButtonContainer,
} from "./Styled";

export default function NoResultFound({ resetSearch }: NoResultFoundPropType) {
  const { setSelectedMode } = React.useContext(appContext);
  const isLessThan1024 = useMediaQuery("(max-width:1025px)");

  const handleOnTemplateClick = () => {
    setSelectedMode(sidebarValueConstants.published);
    resetSearch();
  };

  return (
    <RootContainer>
      <ImageContainer>
        <PreviewImage isLessThan1024={isLessThan1024} src={NoResultImage} />
      </ImageContainer>
      <TextContainer>
        <SubHeaderText>{textConstants.nothingToShow}</SubHeaderText>
        <HeaderText>{textConstants.noResultsBasedOnSearch}</HeaderText>
      </TextContainer>
      <ButtonContainer>
        <TakeToTemplatesButton onClick={handleOnTemplateClick} />
      </ButtonContainer>
    </RootContainer>
  );
}
